import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled, { css } from "styled-components";
import media, { getBreakpointWidth } from "../../utils/mediaQuery";
import defaultTheme from "../../defaultTheme";
import { StyledButton } from "../../Button";
import { rtlSpacing } from "../../utils/rtl";
import { StyledButtonLink } from "../../ButtonLink";
import { withModalContext } from "../ModalContext";
import { QUERIES } from "../../utils/mediaQuery/consts";
var StyledChild = styled.div.withConfig({
  displayName: "ModalFooter__StyledChild",
  componentId: "sc-17ld6v4-0"
})(["flex:", ";box-sizing:border-box;padding:", ";", ";"], function (_ref) {
  var flex = _ref.flex;
  return flex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return rtlSpacing("0 ".concat(theme.orbit.spaceMedium, " 0 0"));
}, media.largeMobile(css(["flex:none;"])));
StyledChild.defaultProps = {
  theme: defaultTheme
};
export var StyledModalFooter = styled.div.withConfig({
  displayName: "ModalFooter__StyledModalFooter",
  componentId: "sc-17ld6v4-1"
})(["display:flex;z-index:800;width:100%;background-color:", ";padding:", ";box-sizing:border-box;transition:box-shadow ", " ease-in-out;@media (max-width:", "px){", ",", "{font-size:", ";height:", ";}}", ";", ":last-of-type{padding:0;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.paletteWhite;
}, function (_ref4) {
  var theme = _ref4.theme;
  return rtlSpacing("0 ".concat(theme.orbit.spaceMedium, " ").concat(theme.orbit.spaceMedium));
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.durationFast;
}, function (_ref6) {
  var theme = _ref6.theme;
  return +getBreakpointWidth(QUERIES.LARGEMOBILE, theme, true) - 1;
}, StyledButton, StyledButtonLink, function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.fontSizeButtonNormal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.heightButtonNormal;
}, media.largeMobile(css(["justify-content:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], function (_ref9) {
  var children = _ref9.children;
  return children.length > 1 ? "space-between" : "flex-end";
}, function (_ref10) {
  var isMobileFullPage = _ref10.isMobileFullPage;
  return !isMobileFullPage && "9px";
}, function (_ref11) {
  var isMobileFullPage = _ref11.isMobileFullPage;
  return !isMobileFullPage && "9px";
})), StyledChild);
StyledModalFooter.defaultProps = {
  theme: defaultTheme
};

var ModalFooter =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ModalFooter, _React$PureComponent);

  function ModalFooter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalFooter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalFooter)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "callContextFunctions", function () {
      var _this$props = _this.props,
          setDimensions = _this$props.setDimensions,
          decideFixedFooter = _this$props.decideFixedFooter;

      if (setDimensions) {
        setDimensions();
      }

      if (decideFixedFooter) {
        decideFixedFooter();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderWrappedChildren", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          _this$props2$flex = _this$props2.flex,
          flex = _this$props2$flex === void 0 ? "0 1 auto" : _this$props2$flex;

      var getChildFlex = function getChildFlex(key) {
        return Array.isArray(flex) && flex.length !== 1 ? flex[key] || flex[0] : flex;
      };

      return React.Children.map(children, function (child, key) {
        if (child) {
          return React.createElement(StyledChild, {
            flex: getChildFlex(key)
          }, React.cloneElement(child, {
            ref: function ref(node) {
              // Call the original ref, if any
              var ref = child.ref;

              if (typeof ref === "function") {
                ref(node);
              } else if (ref !== null) {
                ref.current = node;
              }
            }
          }));
        }

        return null;
      });
    });

    return _this;
  }

  _createClass(ModalFooter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.callContextFunctions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        this.callContextFunctions();
        var manageFocus = this.props.manageFocus;

        if (manageFocus) {
          manageFocus();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          dataTest = _this$props3.dataTest,
          isMobileFullPage = _this$props3.isMobileFullPage;
      return React.createElement(StyledModalFooter, {
        "data-test": dataTest,
        isMobileFullPage: isMobileFullPage
      }, Array.isArray(children) ? this.renderWrappedChildren() : children);
    }
  }]);

  return ModalFooter;
}(React.PureComponent);

var DecoratedComponent = withModalContext(ModalFooter); // $FlowFixMe flow doesn't recognize displayName for functions

DecoratedComponent.displayName = "ModalFooter";
export default DecoratedComponent;